import { useMemo } from 'react';
import { useParams as _useParams, useLocation } from 'react-router-dom';

import type { QueryParams, Route, RouteName, RouteParams } from './types';
import { findRouteByPathname, getSearchQuery } from './util';

/**
 * Get current route object.
 */
export function useCurrentRoute(): (Route & { name: RouteName }) | undefined {
  const location = useLocation();

  return findRouteByPathname(location.pathname);
}

export function useQueryParams<T extends QueryParams>(): T {
  const location = useLocation();
  return useMemo(() => {
    return getSearchQuery(location?.search);
  }, [location?.search]);
}

export function useParams<T extends Record<string, unknown>>() {
  return _useParams<RouteParams & T>();
}
